export function accessReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_ACCESS":            
        case "UPDATE_ACCESS":
            let list = Object.assign({}, state);
            list[payload.access_id] = payload
        
            return list
            
        case "GET_ACCESS":
            return payload

        case "DELETE_ACCESS":            
            let list2 = Object.assign({}, state);
    
            delete list2[payload.access_id]
            return list2
        default:
            return state;
    }
    
}